import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';

import { IAccountSettings } from './settings-jobs-assignment-account.model';

@Injectable()
export class SettingsJobsAssignmentAccountService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private translation: NDDTranslationService,
        private loggerService: LoggerService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-jobs-assignment`;
    }

    public getAccountSettings(): Observable<IAccountSettings> {
        return this.http.get<IAccountSettings>(`${ this.apiUrl }/account`);
    }

    public isAccountSettingsProcessing(): Observable<boolean> {
        return this.http.get<boolean>(`${ this.apiUrl }/is-account-processing`);
    }

    public updateAccountCodeSettings(value: boolean): Observable<boolean> {
        const command: any = { showAccountCode: value };

        return this.http.post<boolean>(`${ this.apiUrl }/update-account-code`, command);
    }

    public updateAccountTypeSettings(command: any): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/update-account-type`, command)
            .pipe(tap(() => this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')])));
    }
}
